<template>
  <div><PageTable /></div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-hxBiz-hxFtyInvInNotice',
  components: { PageTable },
}
</script>
